export default __webpack_public_path__ + "static/media/RENDER_PERFUMES_.a32d7786.png";